class InvoiceDetailsController {
    private onUpdate: any;

    constructor(private $state: ng.ui.IStateService) {
        'ngInject';       
        // console.log('InvoiceDetailController');
    }

    deleteInvoice() {
        // console.log('delete invoice');
        this.onUpdate({action: 'delete'});
    }

    sendToTwinfield() {
        // console.log('sendToTwinfield');
        this.onUpdate({action: 'send'});
    }
}

export const invoiceDetailsComponent = {
    bindings: {
        invoice: '<',
        proformaInvoicesOnly: '<',
        onUpdate: '&'
    },
    controller: InvoiceDetailsController,
    template: require('./invoiceDetails.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/quotations/invoiceDetails.component.ts